import { render, staticRenderFns } from "./ViewPosts.vue?vue&type=template&id=4af76023"
import script from "./ViewPosts.vue?vue&type=script&lang=js"
export * from "./ViewPosts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports